<form>
  <div class="registration-container">
    <div class="modal-body d-flex p-0">
      <div class="col-12 col-md-6 d-flex p-sm-5 p-md-4 p-lg-5 p-5 flex-column step-wizard bgForIE" #signupScroll>

        <mat-stepper #stepper [linear]="true">
          <mat-step class="p-0">
            <div class="wizard">
              <ul>
                <li class="active">
                  <a class="p-0"><i class="fas fa-check"></i></a>
                </li>
                <li>
                  <a class="p-0" (click)="onNextClick(stepper)"></a>
                </li>
              </ul>
            </div>
            <h5 class="h5 mb-0 pe-5 me-4 pb-2">
              {{userPersistenceService.generalTranslation.RegisterForFree}}
            </h5>
            <caption class="text-font12half m-0 p-0 grey-muted d-flex mb-3">
              {{userPersistenceService.generalTranslation.AllFieldsRequired}}
            </caption>

            <div class="mb-3">
              <ifc-select name="registerPage1.title"
                title="{{userPersistenceService.generalTranslation.Salutation}}"
                label="{{userPersistenceService.generalTranslation.Salutation}}" [form]="form"
                [schema]="schema" [options]="dropDowns.titles" labelprop="text" valueprop="key">
              </ifc-select>
            </div>
            <div class="mb-3">
              <ifc-input-field name="registerPage1.firstName"
                title="{{userPersistenceService.generalTranslation.FirstName}}"
                label="{{userPersistenceService.generalTranslation.FirstName}}" [form]="form"
              [schema]="schema" maxlength="40"></ifc-input-field>
            </div>
            <div class="mb-3 registerErrorField">
              <ifc-input-field name="registerPage1.lastName"
                title="{{userPersistenceService.generalTranslation.LastName}}"
                label="{{userPersistenceService.generalTranslation.LastName}}" [form]="form"
              [schema]="schema" maxlength="40"></ifc-input-field>
            </div>
            <div class="mb-3">
              <ifc-select name="registerPage1.gender"
                title="{{userPersistenceService.generalTranslation.Gender}}"
                label="{{userPersistenceService.generalTranslation.Gender}}" [form]="form"
                [schema]="schema" [options]="dropDowns.registrationGender" labelprop="text" valueprop="key">
              </ifc-select>
            </div>
            <div class="mb-3 registerErrorField">
              <ifc-input-field name="registerPage1.email"
                title="{{userPersistenceService.generalTranslation.EmailUserName}}"
                label="{{userPersistenceService.generalTranslation.EmailUserName}}" [form]="form"
              [schema]="schema" maxlength="100"></ifc-input-field>
            </div>
            <div class="mb-3 password-type">
              <ifc-input-field name="registerPage1.password"
                title="{{userPersistenceService.generalTranslation.RegisterPassword}}"
                label="{{userPersistenceService.generalTranslation.RegisterPassword}}" type="password"
              maxlength="40" [form]="form" [schema]="schema" cssClass="mb-0"></ifc-input-field>
              <caption class="text-font12half m-0 p-0 grey-muted d-flex">
                {{userPersistenceService.generalTranslation.ChangePasswordHint}}
              </caption>
            </div>
            <div class="mb-3">
              <ifc-input-field name="registerPage1.confirmPassword"
                title="{{userPersistenceService.generalTranslation.ConfirmPwd}}"
                label="{{userPersistenceService.generalTranslation.ConfirmPwd}}" type="password"
              maxlength="40" [form]="form" [schema]="schema"></ifc-input-field>
            </div>
            <button type="button" (click)="onNextClick(stepper)" mat-raised-button color="primary"
              class="text-uppercase body2 pt-2 pb-2 px-5 no-shadow rounded m-0">
              {{userPersistenceService.generalTranslation.Next}}
            </button>
          </mat-step>
          <mat-step class="p-0 step2">
            <div class="step2 wizard">
              <ul>
                <li>
                  <a class="p-0" (click)="stepper.previous()">
                    <i class="fas fa-check"></i>
                  </a>
                </li>
                <li class="active">
                  <a class="p-0"><i class="fas fa-check"></i></a>
                </li>
              </ul>
            </div>
            <h5 class="h5 mb-0 pe-5 me-4">{{userPersistenceService.generalTranslation.RegisterForFree}}</h5>
            <caption class="text-font12half m-0 p-0 grey-muted d-flex mb-3">
            {{userPersistenceService.generalTranslation.AllFieldsRequiredExceptionMobile}}</caption>
            <div class="mb-3 select-country-dd">
              <ifc-select-country-with-code name="registerPage2.countryId"
                title="{{userPersistenceService.generalTranslation.CountryResidence}}"
                label="{{userPersistenceService.generalTranslation.CountryResidence}}"
                [options]="dropDowns.countries" [form]="form" [schema]="schema"
                (onSelection)="setPhoneCode($event)" labelprop="text" valueprop="key">
              </ifc-select-country-with-code>

            </div>
            <div class="mb-3 m-0 p-0 d-flex">
              <div class="w-20 pe-2">
                <ifc-input-field name="registerPage2.phoneCode"
                  title="{{userPersistenceService.generalTranslation.Code}}"
                  label="{{userPersistenceService.generalTranslation.Code}}" [form]="form"
                [schema]="schema" cssClass="m-0 p-0" maxlength="10"></ifc-input-field>
              </div>
              <div class="w-80">
                <ifc-input-field name="registerPage2.mobile"
                  title="{{userPersistenceService.generalTranslation.Mobile}}"
                  label="{{userPersistenceService.generalTranslation.Mobile}}" [form]="form"
                [schema]="schema" cssClass="m-0 p-0" maxlength="40"></ifc-input-field>
              </div>
            </div>
            <div class="mb-3">
              <ifc-input-field name="registerPage2.organization"
                title="{{userPersistenceService.generalTranslation.CompanyLabel}}"
                label="{{userPersistenceService.generalTranslation.CompanyLabel}}" [form]="form"
              [schema]="schema" maxlength="100"></ifc-input-field>
            </div>
            <div class="mb-3">
              <ifc-auto-complete name="registerPage2.otherJobTitle"
                title="{{userPersistenceService.generalTranslation.JobTitle}}"
                label="{{userPersistenceService.generalTranslation.JobTitle}}"
                [options]="jobTitleDropdownData" [form]="form" [schema]="schema"
                [showCloseIcon]="jobTitleId" (onSelection)="onJobTitleSelect($event)"
                (onClear)="onJobTitleClear()" (onTextChange)="onJobTitleChange($event)" labelprop="text"
              valueprop="key" maxlength="100"></ifc-auto-complete>
            </div>
            <div class="mb-3 text-loginlabel agree-privacy-policy">
              <ifc-checkbox cssClass="p-0" name="registerPage2.agreeToPrivacyPolicy" [form]="form"
                [schema]="schema"
              [label]="userPersistenceService.generalTranslation.RegistrationConfirmationMsg"></ifc-checkbox>
            </div>
            <div class="mb-3 text-loginlabel agree-privacy-policy">
              <ifc-checkbox cssClass="p-0" name="registerPage2.wishToReceiveEmail" [form]="form"
                [schema]="schema"
              [label]="userPersistenceService.generalTranslation.WishToReceiveEmail"></ifc-checkbox>
            </div>

            <div [hidden]="!captchaLoaded" class="my-3">
              <ifc-captcha name="recaptcha" [captchaLoaded]="captchaLoaded"
                (captchaLoadedEvent)="captchaLoaded = $event"
                (captchaResponseEvent)="getCaptchaResponse = $event"
                [getCaptchaResponse]="getCaptchaResponse" [form]="form.controls.registerPage2"
              [schema]="registerPage2Schema"></ifc-captcha>
            </div>
            @if (!captchaLoaded) {
              <div class="captcha-block border-muted background-whitefs p-2 mt-4 mb-3"
                >
                <caption class="text-font12half m-0 p-0 grey-muted d-flex">
                  {{userPersistenceService.generalTranslation.CaptchaHeader}}
                </caption>
                <div class="d-flex">
                  <div class="mb-3 p-0 m-0 align-self-center">
                    <img src="{{signup.captchaSrc}}" alt="captcha" />
                  </div>
                  <div>
                    <ifc-input-field cssClass="mb-0 mt-3 mx-2 p-0" name="registerPage2.captchaInput"
                    [form]="form" [schema]="schema"></ifc-input-field>
                  </div>
                  <div class="mb-3 p-0 m-0">
                    <button type="button" class="btn"
                      (click)="getMathCaptcha()"
                      title="{{userPersistenceService.generalTranslation.ReloadCaptcha}}"><i
                    class="fas fa-sync-alt" aria-hidden="true"></i></button>
                  </div>
                </div>
              </div>
            }

            <button type="button" (click)="register()" mat-raised-button color="primary"
              class="text-uppercase body2 pt-2 pb-2 px-5 no-shadow rounded m-0">
              {{ userPersistenceService.generalTranslation.GetStarted }}
            </button>
            <!--matStepperPrevious-->
          </mat-step>

        </mat-stepper>
        <div class="d-flex flex-row justify-content-between mt-3 mb-0 hide-upto-ipad">
          {{ userPersistenceService.generalTranslation.AlreadyHaveAnAccount }}
        </div>
        <div class="d-flex flex-row justify-content-between mt-0 mb-3 hide-upto-ipad">
          <button type="button" mat-stroked-button color="primary"
            class="text-uppercase body2 pt-2 pb-2 no-shadow rounded my-3 ms-0"
            (click)="onLoginClick()">
            {{userPersistenceService.generalTranslation.SignIn}}
          </button>
        </div>
        <div class="d-flex flex-column justify-content-end flex-grow-1 mb-3 mt-5">
          <p class="text-font12half grey-muted mb-0"
          [innerHTML]="userPersistenceService.generalTranslation.ForMoreInfo"></p>
          <p class="text-font12half grey-muted mb-0">
            {{userPersistenceService.generalTranslation.Copyright}}
            {{userPersistenceService.generalTranslation.Trademark}}
          </p>
        </div>
      </div>
      <div class="col-md-6 p-0 d-flex justify-content-center align-items-center login-left hide-below-ipad">
        <div class="col-8 ms-auto me-auto">
          <h5 class="mb-0 text-white">{{userPersistenceService.generalTranslation.ReceiveUnlimitedAccess}}
          </h5>
          <div class="w-50 mt-4 mb-4 align-left half-border-2px"></div>
          <ul class="text-white h6 unordered-list ps-4">
            <li>{{userPersistenceService.generalTranslation.SaveAnyNoProject}}</li>
            <li>{{userPersistenceService.generalTranslation.VerifyDesignEfficiency}}</li>
            <li>{{userPersistenceService.generalTranslation.EstimateInvestment}}</li>
            <li>{{userPersistenceService.generalTranslation.BringProjectForCertification}}</li>
          </ul>
          <h6 class="mb-3 text-white h6">
            {{userPersistenceService.generalTranslation.OutshineTheCompetition}}
          </h6>
          <div class="w-50 mt-4 mb-4 align-left half-border-2px"></div>
          <h5 class="mb-3 text-white">{{userPersistenceService.generalTranslation.AlreadyHaveAnAccount}}</h5>
          <button type="button" mat-raised-button color="primary"
            class="btn btn-register text-uppercase body2 pt-2 pb-2 no-shadow rounded m-0"
            (click)="onLoginClick()">
            {{userPersistenceService.generalTranslation.SignIn}}
          </button>
        </div>
      </div>
    </div>
  </div>

</form>

